import React from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/erp/ui";

export const KpiPoints = ({ start, end, email = "" }) => {
  const [all, setRows] = React.useState([]);
  const rows = email ? all.filter((r) => r.email === email) : all;
  React.useEffect(() => { api.get("/design/kpi-points", { params: { start, end } }).then(({ data }) => setRows(data.rows || [])).catch(() => setRows([])); }, [start, end]);
  return (
    <Card className="p-4" data-testid="design-kpi-points">
      <div className="text-sm font-semibold mb-2">Poin KPI WO Design selesai ({start} – {end})</div>
      <div className="flex flex-wrap gap-2">
        {rows.map((r) => <span key={r.email} className="text-xs px-3 py-1 rounded-full bg-emerald-50 text-emerald-700" data-testid={`kpi-points-${r.email}`}>{r.name}: <b>{r.points}</b> WO</span>)}
        {rows.length === 0 && <span className="text-xs text-slate-400">Belum ada WO design selesai di periode ini</span>}
      </div>
      <p className="text-[11px] text-slate-400 mt-2">Dari awal dikerjakan tim: dibagi sesuai persen (default rata). Take over karena absen / lewat target / lewat deadline / skill belum memadai: poin penuh ke pengerja terakhir. Take over alasan lain: dibagi sesuai jam kerja.</p>
    </Card>
  );
};
